module.exports = __webpack_public_path__ + "static/BannerBPK3-826a49ade0dc7257a014295cef5c5694.jpg";